(function () {
  // Detecta si el par de indicadores se renderiza como 1 glyph (emoji)
  function supportsFlagEmoji() {
    const el = document.createElement('span');
    el.style.fontFamily = '"Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji","Noto Emoji"';
    el.textContent = '🇮🇸'; // cualquier bandera
    document.body.appendChild(el);
    const width1 = el.getBoundingClientRect().width;
    el.textContent = '🇮' + '🇸'; // dos símbolos separados
    const width2 = el.getBoundingClientRect().width;
    document.body.removeChild(el);
    return width1 < width2; // si es 1 glyph, el ancho es menor
  }

  if (supportsFlagEmoji()) return;

  // Reemplaza banderas por SVG Twemoji en el header y drawer
  const scope = document.querySelectorAll('.header, header, .menu-drawer');
  const FLAG_RE = /[\uD83C][\uDDE6-\uDDFF][\uD83C][\uDDE6-\uDDFF]/g; // pares regionales

  function toTwemojiUrl(flag) {
    // convierte a formato "1f1ee-1f1f8.svg"
    const codePoints = [];
    for (const ch of flag) codePoints.push(ch.codePointAt(0).toString(16));
    return `https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${codePoints.join('-')}.svg`;
  }

  scope.forEach(root => {
    root.querySelectorAll('a, summary, .list-menu__item, .mega-menu__link, .menu-drawer__menu-item').forEach(node => {
      const txt = node.textContent;
      const match = txt && txt.match(FLAG_RE);
      if (!match) return;
      node.innerHTML = node.innerHTML.replace(FLAG_RE, m => {
        const url = toTwemojiUrl(m);
        return `<img src="${url}" alt="${m}" class="flag-emoji-svg" style="width:1.1em;height:1.1em;vertical-align:-0.15em;margin-right:.35em">`;
      });
    });
  });
})();
